module.exports = __webpack_public_path__ + "img/agent-seal.6c92e5a.png";